import * as React from 'react';
import { BaseButton, ButtonLook, ButtonProps } from './base_button';

// A button that has transparent background but is otherwise styled like a button
export const LinkButton = (props: ButtonProps) => (
  <BaseButton look={ButtonLook.LINK} {...props}/>
);
